import { render, staticRenderFns } from "./PannelSeven.vue?vue&type=template&id=5b8afe77&scoped=true&"
import script from "./PannelSeven.vue?vue&type=script&lang=js&"
export * from "./PannelSeven.vue?vue&type=script&lang=js&"
import style0 from "./PannelSeven.vue?vue&type=style&index=0&id=5b8afe77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8afe77",
  null
  
)

export default component.exports